// Stage 48 §17.5: reusable copy-once display for plaintext tokens.

import { useState } from 'react';

export function RevealOnceField({
  value,
  label = 'Token',
}: {
  value: string;
  label?: string;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <div className="reveal-once">
      <label className="reveal-once-label">{label}</label>
      <div className="reveal-once-row">
        <input
          type="text"
          readOnly
          value={value}
          spellCheck={false}
          autoComplete="off"
          onFocus={(e) => e.currentTarget.select()}
          aria-label={label}
        />
        <button
          type="button"
          className="btn-primary"
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(value);
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            } catch {
              /* clipboard may be blocked; the user can still select+copy */
            }
          }}
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <p className="muted small">
        This will not be shown again. Save it now.
      </p>
    </div>
  );
}
